import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=36cd1845&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=36cd1845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd1845",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36cd1845')) {
      api.createRecord('36cd1845', component.options)
    } else {
      api.reload('36cd1845', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=36cd1845&scoped=true&", function () {
      api.rerender('36cd1845', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2D83EQnMSEvQX/JS/comp/GuestBox.vue"
export default component.exports